export class ShipmentsKpi {
  submittedQuantity = 0;
  submittedValue = 0;
  requestedQuantity = 0;
  requestedValue = 0;
  acceptedQuantity = 0;
  acceptedValue = 0;
  purchasePrice = 0;
}
